import React, {useEffect, useState} from "react";

import {Button, DatePicker, Form, Modal, Select} from "antd";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {useStore} from "../../../../hooks/useStore";

export const CreatePoolForecastModal = ({
    poolId,
    shiftHours = [],
    visible,
    setVisible,
    recall = () => {}
}) => {
    const stores = useStore();
    const [shiftStartHourId, setShiftStartHourId] = useState(null);
    const [shiftEndHourId, setShiftEndHourId] = useState(null);
    const [date, setDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState(null);
    const {t} = useTranslation("pools");

    const resetForm = () => {
        setShiftStartHourId(null);
        setShiftEndHourId(null);
        setDate(null);
        setErrors(null);
    };

    const validate = () => {
        const tmpErrors = {};
        if (!date) {
            tmpErrors.date = "Tarih alanı boş bırakılamaz";
        }
        if (!shiftStartHourId) {
            tmpErrors.shiftStartHourId = "Başlangıç Saati alanı boş bırakılamaz";
        }
        if (!shiftEndHourId) {
            tmpErrors.shiftEndHourId = "Bitiş Saati alanı boş bırakılamaz";
        }
        setErrors(tmpErrors);
        return Object.keys(tmpErrors).length === 0;
    };

    const handleCreatePoolForecast = async () => {
        setLoading(true);
        if (!validate()) {
            setLoading(false);
            return;
        }
        try {
            const payload = {
                poolId,
                date: date?.format("YYYY-MM-DD"),
                shiftStartHourId,
                shiftEndHourId
            };
            const isRequestSuccess = await stores.poolShiftStore.setDailyForecast(payload);
            if (isRequestSuccess) {
                setVisible(false);
                recall();
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!visible) {
            resetForm();
        }
    }, [visible]);

    return (
        <Modal
            aria-modal="true"
            alt="createPoolForecastModal"
            title={"Forecast Oluştur"}
            visible={visible}
            onCancel={() => setVisible(false)}
            footer={[
                <Button key="back" onClick={() => setVisible(false)}>
                    İptal
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={handleCreatePoolForecast}
                >
                    Oluştur
                </Button>
            ]}
        >
            <Form layout="vertical" alt="createPoolForecastForm">
                <Form.Item
                    label={"Tarih"}
                    validateStatus={errors?.date ? "error" : "success"}
                    help={errors?.date ? errors?.date : null}
                >
                    <DatePicker
                        data-testid="date"
                        value={date}
                        onChange={value => setDate(value)}
                        disabledDate={currentDate =>
                            currentDate && currentDate < moment().startOf("day")
                        }
                    />
                </Form.Item>

                <Form.Item
                    label={"Başlangıç Saati"}
                    validateStatus={errors?.shiftStartHourId ? "error" : "success"}
                    help={errors?.shiftStartHourId ? errors?.shiftStartHourId : null}
                >
                    <Select
                        data-testid="shiftStartHourId"
                        value={shiftStartHourId}
                        onChange={value => setShiftStartHourId(value)}
                    >
                        {shiftHours?.map(shiftHour => (
                            <Select.Option key={shiftHour?._id} value={shiftHour?._id}>
                                {`${shiftHour?.startTime}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label={"Bitiş Saati"}
                    validateStatus={errors?.shiftEndHourId ? "error" : "success"}
                    help={errors?.shiftEndHourId ? errors?.shiftEndHourId : null}
                >
                    <Select
                        data-testid="shiftEndHourId"
                        value={shiftEndHourId}
                        onChange={value => setShiftEndHourId(value)}
                    >
                        {shiftHours?.map(shiftHour => (
                            <Select.Option key={shiftHour?._id} value={shiftHour?._id}>
                                {`${shiftHour?.endTime}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};
